module.exports = __webpack_public_path__ + "img/SysComm2.3dbcf766.png";